
import {of as observableOf,  Observable } from 'rxjs';

import {catchError} from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { AddTeam, UpdateTeam } from '@routes/usersteams/models/team-model';
import { ErrorResponse, SuccessResponse } from '@shared/services/api/legacy/response';
import { ITeamDetails, ITeams, ITeamsForDropdown } from '@shared/services/api/dashboard/teams-service/team-model';

@Injectable({ providedIn: 'root' })
export class TeamsService {
    constructor(private http: HttpClient) { }

    private static get URL(): string { return `${environment.dashboardApi.baseUrl}${environment.dashboardApi.prefix}${TeamsService.ENDPOINT}`; }
    private static readonly ENDPOINT = 'teams';

    public getTeam(id: string): Observable<SuccessResponse<ITeamDetails> | ErrorResponse> {
        return this.http
            .get<SuccessResponse<ITeamDetails>>(TeamsService.URL + '/' + id).pipe(
            catchError(error => observableOf(new ErrorResponse(error.error))));
    }

    public getTeams(): Observable<SuccessResponse<ITeams> | ErrorResponse> {
        return this.http
            .get<SuccessResponse<ITeams>>(TeamsService.URL).pipe(
            catchError(error => observableOf(new ErrorResponse(error.error))));
    }

    public getTeamsForDropdown(): Observable<SuccessResponse<ITeamsForDropdown> | ErrorResponse>  {
        return this.http
            .get<SuccessResponse<ITeamsForDropdown>>(TeamsService.URL + '/dropdowns').pipe(
            catchError(error => observableOf(new ErrorResponse(error.error))));
    }

    public addTeam(team: AddTeam): Observable<SuccessResponse<boolean> | ErrorResponse> {
        return this.http
            .post<SuccessResponse<boolean>>(TeamsService.URL, team).pipe(
            catchError(error => observableOf(new ErrorResponse(error.error))));
    }

    public updateTeam(team: UpdateTeam): Observable<SuccessResponse<boolean> | ErrorResponse> {
        return this.http
            .put<SuccessResponse<boolean>>(TeamsService.URL + '/' + team.id, team).pipe(
            catchError(error => observableOf(new ErrorResponse(error.error))));
    }

    public deleteTeam(id: string): Observable<SuccessResponse<boolean> | ErrorResponse> {
        return this.http
            .delete<SuccessResponse<boolean>>(TeamsService.URL + '/' + id).pipe(
            catchError(error => observableOf(new ErrorResponse(error.error))));
    }
}
